module.exports = __webpack_public_path__ + "images/feature/20190613-dbca3020853216158cd1ca48b3a7f889.png";